module.exports = __webpack_public_path__ + "static/media/sandeep.25174c1f.png";